// src/storage/anon-storage.ts
function store() {
  try {
    if (typeof window === "undefined") return null;
    return window.localStorage || null;
  } catch {
    return null;
  }
}
var KEY_PREFIX = "_chanl_anon_";
var ANON_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function makeKey(publicKey) {
  return `${KEY_PREFIX}${publicKey}`;
}
function mintId() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
      const b = crypto.getRandomValues(new Uint8Array(16));
      b[6] = b[6] & 15 | 64;
      b[8] = b[8] & 63 | 128;
      const h = Array.from(b, (x) => x.toString(16).padStart(2, "0"));
      return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
    }
  } catch {
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
}
function readAnonymousId(publicKey) {
  try {
    const ls = store();
    if (!ls) return null;
    const stored = ls.getItem(makeKey(publicKey));
    return stored && ANON_ID_RE.test(stored) ? stored : null;
  } catch {
    return null;
  }
}
function getOrCreateAnonymousId(publicKey) {
  const existing = readAnonymousId(publicKey);
  if (existing) return existing;
  const id = mintId();
  try {
    const ls = store();
    if (ls) ls.setItem(makeKey(publicKey), id);
  } catch {
  }
  return id;
}

export { getOrCreateAnonymousId, readAnonymousId };
//# sourceMappingURL=chunk-5ULK5JKE.mjs.map
//# sourceMappingURL=chunk-5ULK5JKE.mjs.map